// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1UgNo","consentsList":"PatientConsents_consentsList__2l0Ml","consentsListEmpty":"PatientConsents_consentsListEmpty__1VBpV"};